import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class MGMTCertificateService extends BaseService {
	constructor() {
		super('/MGMTCertificate');
	}

	public getAllByFilter(filter: MGMTCertificateFilter) {
		return super.getAllByFilterBase(filter);
	}

    public updateCertificate(id: number, form: any) {
        return super.updateBase(this._resourceName + '/updateCertificate/' + id, form);
	}

	/*aktualizace tagu u componenty */
	//public updateReceiverCertificate(id: number, tags: any) {
	//	return super.updateBase(this._resourceName + '/receiver-tag/' + id, tags);
	//}

	///*aktualizace jednoho tagu ke componentam */
	//public updateCertificateToReceiver(id: number, components: any) {
	//	return super.updateBase(this._resourceName + '/tag-to-receiver/' + id, components);
	//}

	//public deleteList(list: number[]) {
	//	return this.deleteListWithResourceName(list, 'delete-list')
	//}
}


export class MGMTCertificateFilter extends BaseFilter {
	constructor(idTenant?: number | null) {
		super();
		this._idTenant = idTenant;
	}

	private _idTenant?: number | null;

	public getAllParams(): {} {

		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})
		);

		return data;
	};
}